"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleQuery = exports.VehicleUpdate = exports.VehicleCreate = exports.VehicleTransport = exports.TruckTypeLabels = exports.TruckType = exports.TruckTypes = exports.VehicleStatusLabels = exports.VehicleStatus = exports.VehicleStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const container_type_1 = require("../container/container-type");
/**
 * Needs to allow 2 years in the future for the cab year since
 * the vehicle may be a new model year. (e.g. 2023 Model in 2021)
 */
const ValidYears = typebox_1.Type.Integer({
    minimum: 1900,
    maximum: new Date().getFullYear() + 2,
});
/**
 * Enum representing the possible statuses of a vehicle.
 */
exports.VehicleStatuses = ['ACTIVE', 'INACTIVE', 'REMOVED_FROM_INVENTORY'];
/**
 * Union type representing the possible statuses of a vehicle.
 */
exports.VehicleStatus = typebox_1.Type.Union(exports.VehicleStatuses.map((status) => typebox_1.Type.Literal(status)));
/**
 * Object mapping vehicle statuses to their corresponding labels.
 */
exports.VehicleStatusLabels = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    REMOVED_FROM_INVENTORY: 'Removed from Inventory',
};
/**
 * Enum representing the possible types of trucks.
 */
exports.TruckTypes = [
    'FRONT_LOAD',
    'REAR_LOAD',
    'SIDE_LOAD',
    'ROLL_OFF',
    'CONTAINER_DELIVERY',
    'BOX_TRUCK',
    'RACK_BODY',
    'TRACTOR_CAB',
    'PICK_UP',
];
/**
 * Union type representing the possible types of trucks.
 */
exports.TruckType = typebox_1.Type.Union(exports.TruckTypes.map((type) => typebox_1.Type.Literal(type)));
/**
 * Object mapping truck types to their corresponding labels.
 */
exports.TruckTypeLabels = {
    FRONT_LOAD: 'Front Load',
    REAR_LOAD: 'Rear Load',
    SIDE_LOAD: 'Side Load',
    ROLL_OFF: 'Roll Off',
    CONTAINER_DELIVERY: 'Container Delivery',
    BOX_TRUCK: 'Box Truck',
    RACK_BODY: 'Rack Body',
    TRACTOR_CAB: 'Tractor Cab',
    PICK_UP: 'Pick Up',
};
/**
 * Type representing the vehicle transport information.
 */
exports.VehicleTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    status: exports.VehicleStatus,
    truckType: exports.TruckType,
    /**
     * The body size of the vehicle in cubic yards.
     */
    bodySize: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    truckNumber: typebox_1.Type.String(),
    dotRegistrationNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    stateRegistrationNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    cabYear: typebox_1.Type.Optional(ValidYears),
    cabMake: typebox_1.Type.Optional(typebox_1.Type.String()),
    cabModel: typebox_1.Type.Optional(typebox_1.Type.String()),
    cabVIN: typebox_1.Type.Optional(typebox_1.Type.String()),
    bodyMake: typebox_1.Type.Optional(typebox_1.Type.String()),
    bodyModel: typebox_1.Type.Optional(typebox_1.Type.String()),
    licensePlate: typebox_1.Type.String(),
    grossVehicleWeight: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    rollOffRailStyle: typebox_1.Type.Optional(container_type_1.RollOffRailStyle),
    metadata: common_1.MetaData,
});
/**
 * Type representing the input for creating a vehicle.
 */
exports.VehicleCreate = typebox_1.Type.Omit(exports.VehicleTransport, ['id', 'metadata']);
/**
 * Type representing the input for updating a vehicle.
 */
exports.VehicleUpdate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(typebox_1.Type.Partial(exports.VehicleCreate), [
        'cabYear',
        'cabMake',
        'cabModel',
        'cabVIN',
        'bodyMake',
        'bodyModel',
        'notes',
        'dotRegistrationNumber',
        'stateRegistrationNumber',
    ]),
    typebox_1.Type.Object({
        dotRegistrationNumber: (0, common_1.Nullable)(typebox_1.Type.String()),
        stateRegistrationNumber: (0, common_1.Nullable)(typebox_1.Type.String()),
        cabYear: (0, common_1.Nullable)(ValidYears),
        cabMake: (0, common_1.Nullable)(typebox_1.Type.String()),
        cabModel: (0, common_1.Nullable)(typebox_1.Type.String()),
        cabVIN: (0, common_1.Nullable)(typebox_1.Type.String()),
        bodyMake: (0, common_1.Nullable)(typebox_1.Type.String()),
        bodyModel: (0, common_1.Nullable)(typebox_1.Type.String()),
        notes: (0, common_1.Nullable)(typebox_1.Type.String()),
    }),
]);
/**
 * Type representing the query for fetching vehicles.
 */
exports.VehicleQuery = typebox_1.Type.Intersect([common_1.BaseQuery, typebox_1.Type.Object({ truckType: typebox_1.Type.Optional(exports.TruckType) })]);
//# sourceMappingURL=vehicle-transport.js.map